export const OVERALL_CAMPAIGN_GOALS = {
  RAISE_AWARENESS: 'Raise awareness of my brand or product',
  DRIVE_ONLINE: 'Drive online action or visits',
  DRIVE_OFFLINE: 'Drive offline or in-store sales',
  DRIVE_APP: 'Drive app installs or engagements',
};
export const CPV = 'CPV';
export const CPM = 'CPM';
export const VIEWABLE_PERCENT = 'Viewable %';
export const CPIAVC = 'CPIAVC';
export const CPA = 'CPA';
export const CPC = 'CPC';
export const CTR = 'CTR';
export const OTHER = 'Other';

export const KPI_LIST_DEFAULT = [
  CPV,
  CPM,
  VIEWABLE_PERCENT,
  CPIAVC,
  CPA,
  CPC,
  CTR,
  OTHER,
];

export const KPI_LIST_DRIVE_ONLINE_APP = [
  CPM,
  CPC,
  CPA,
  CTR,
  VIEWABLE_PERCENT,
  CPV,
  CPIAVC,
  OTHER,
];

export const KPI_LISTS_BY_CAMPAIGN_GOALS = {
  [OVERALL_CAMPAIGN_GOALS.RAISE_AWARENESS]: KPI_LIST_DEFAULT,
  [OVERALL_CAMPAIGN_GOALS.DRIVE_ONLINE]: KPI_LIST_DRIVE_ONLINE_APP,
  [OVERALL_CAMPAIGN_GOALS.DRIVE_OFFLINE]: KPI_LIST_DEFAULT,
  [OVERALL_CAMPAIGN_GOALS.DRIVE_APP]: KPI_LIST_DRIVE_ONLINE_APP,
};
